import { useTranslation } from 'react-i18next'
import { formatMarkerValue } from './markerValueFormat'

/** VH-221: a marker value as the lab meant it — "above 52.0", never 0. */
export default function MarkerValue({ result, showUnit = true, className = '' }) {
  const { t } = useTranslation()
  const kind = result?.value_kind || 'numeric'
  const text = formatMarkerValue(result, t)
  const unit = showUnit && result?.unit && kind !== 'unreadable' && kind !== 'qualitative' ? ` ${result.unit}` : ''
  return (
    <span className={className} title={kind === 'unreadable' ? result?.value_text || undefined : undefined}>
      {text}
      {unit}
    </span>
  )
}
